import { GridColDef } from "@mui/x-data-grid";
import { estoqueController, EstoqueViewProps, mapDispatchToEstoqueProps, mapStateToEstoqueProps } from "./estoque.controll";
import { StripedDataGrid } from "../../components/select";
import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import store from "../../store";
import { Box, Card, CardHeader, IconButton, Typography } from "@mui/material";
import Alerts from "../../components/alerts/Alerts";
import { formatData, formatDataCalendar, getDataText } from "../../services/utils";
import { EditCalendar, NoteAlt, Refresh, Restore, SaveAs } from "@mui/icons-material";
import { getConfigDataIniEstoque } from "../config/config.dispatch";
import SetDataInicialEstoque from "../config/config.view"


const columns: GridColDef[] = [
    { field: 'descricao', headerName: 'Item', flex: 8 },
    { field: 'qt', headerName: 'Estoque', flex: 4 },
]


function EstoqueList(props: EstoqueViewProps) {
    const { estoqueActions, estoqueState } = props
    const { estoqueItemView, row, loadingRows, msg, showAlert, status, } = estoqueState;
    const { setShowAlert,readEstoque,reConfigEstoque } = estoqueActions
    const [showSetDataInicialEstoque,setShowDataInicialEstque] = useState(false);
    console.log("props estoque",props)
    const handleReconfigureEstoque = () => {
        alert("Chamou reconfigure Estoque")
        setTimeout(()=>{
            reConfigEstoque();
        },3000)
    }

    return (
        <Card>
            <CardHeader
                title={
                    <Box sx={{ display: "flex", flex: 1, flexDirection: "row" }}>
                        <Box sx={{ flex: 1 }}>
                            <Box sx={{display:"flex", flexDirection: "row", alignItems:"center", gap:1}}>
                                <Typography>Data inicial de calculo do estoque {getDataText(getConfigDataIniEstoque())}</Typography>
                                <IconButton title="Reajustar data de inicio de contagem do estoque" sx={{marginLeft:2}} size="small" onClick={()=>setShowDataInicialEstque(true)}>
                                    <EditCalendar />
                                </IconButton>
                                <IconButton title="Estabilizar estque desde o inicio da contagem" sx={{marginLeft:2}} size="small" onClick={()=>props.estoqueActions.configEstoque(true)}>
                                    <Restore />
                                </IconButton>                                
                                <IconButton title="Memorizar estado do estoque atual" sx={{marginLeft:2}} size="small" onClick={()=>props.estoqueActions.salvarEstoqueAtualizado()}>
                                    <SaveAs />
                                </IconButton>                                 

                            </Box>
                            {row.data&&(
                                <Typography>Estoque memorizado em: {formatData(row.data)}</Typography>
                            )}
                            
                        </Box>
                        <IconButton title="Atualizar Estoque" onClick={readEstoque}>
                            <Refresh />
                        </IconButton>
                    </Box>
                }
            />


            <StripedDataGrid
                disableRowSelectionOnClick
                rows={estoqueItemView}
                columns={columns}
                getRowId={row => row._id}
                density={'compact'}
                style={{ fontSize: '0.875rem' }}
                hideFooterPagination={true}
                hideFooter={true}
                filterMode="client"
                loading={loadingRows}
            />
            <Alerts
                handleClose={() => setShowAlert(false)}
                menssage={msg}
                show={showAlert}
                tipoAlerta={status === "error" ? "error" : "info"}
            />
            <SetDataInicialEstoque 
                handleClose={()=>setShowDataInicialEstque(false)} 
                showModal={showSetDataInicialEstoque} 
                handleConfirme={handleReconfigureEstoque}
            />
        </Card>
    )
}

export default connect(mapStateToEstoqueProps, mapDispatchToEstoqueProps)(EstoqueList);

export const handleReadEstoque = () => {
    store.dispatch(estoqueController.reducer.actions.readEstoque())
}

